/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Manual/view.blocks to change it.
import DefaultStatusSelector from './DefaultStatusSelector/index'
import DefaultStatusToggle from './DefaultStatusToggle/index'
import HelpText from './HelpText/index'
import React from 'react'
import SubsetStatusesSelector from './SubsetStatusesSelector/index'
import SubsetStatusesToggle from './SubsetStatusesToggle/index'



/** @type {import('Simple/types.js').View} */
export default function Manual({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/StatusUpdate/Content/Manual"
  
}) {
  return (<React.Fragment
>
<HelpText
  viewPath={`${viewPath}/HelpText`}
/>
<SubsetStatusesToggle
  viewPath={`${viewPath}/SubsetStatusesToggle`}
/>
<SubsetStatusesSelector
  viewPath={`${viewPath}/SubsetStatusesSelector`}
/>
<DefaultStatusToggle
  viewPath={`${viewPath}/DefaultStatusToggle`}
/>
<DefaultStatusSelector
  viewPath={`${viewPath}/DefaultStatusSelector`}
/>
{children}
</React.Fragment>)
}